'use strict'

class CommonConfig {
    constructor() {
        this.urlApi = process.env.NODE_ENV === 'development' ? 'http://dev.smartix.team/preregistration/v1/auth/point' : './auth/point'
    }

    getUrlApi() {
        return this.urlApi
    }
}

export default new CommonConfig()
